import permCode from "@/config/permCode";

export default [
  {
    permission: [permCode.LARK_ORDER_LIST, permCode.LARK_ADZONE_LIST],
    title: '全域报表',
    sortOrder: 10,
    icon: 'el-icon-menu',
    url: '/lark/index'
  }
]
